import React from 'react';
import '../styling/menus.css';

const Card = ({ title, subtitle, icon, onClick, cardClass }) => (
  <button className={`menu-card ${cardClass || ''}`} onClick={onClick}>
    <div className="menu-icon" aria-hidden>{icon}</div>
    <div className="menu-title">{title}</div>
    {subtitle && <div className="menu-subtitle">{subtitle}</div>}
  </button>
);

const ComplicationsMenu = ({ goBack, toOutcomes, toSettings, logout, onSelect }) => {
  return (
    <div className="menu-screen">
      <h1 className="menu-heading">Complication Report</h1>
      <p className="menu-sub">Select the type of complication to report</p>
      <div className="menu-grid three-cols">
        <Card title="Anesthesia Complications" subtitle="Report anesthesia-related complications and adverse events" icon="🩺" onClick={() => onSelect('Anesthesia')} cardClass="clinical" />
        <Card title="Dental Implant Complications" subtitle="Report complications related to implant procedures" icon="🦷" onClick={() => onSelect('Dental Implant')} cardClass="clinical" />
        <Card title="Dentoalveolar Surgery Complications" subtitle="Report complications from extractions and surgical procedures" icon="🦷" onClick={() => onSelect('Dentoalveolar Surgery')} cardClass="clinical" />
        <Card title="Needle Stick Injury" subtitle="Report needle stick injuries and exposure incidents" icon="💉" onClick={() => onSelect('Needle Stick Injury')} cardClass="clinical" />
      </div>
    </div>
  );
};

export default ComplicationsMenu;


